import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
const ProjectDetails = () => {
    const { projectId } = useParams();
    const [projects, setProjects] = useState([])

    const projectsDetails = [
        {
            id: 1,
            name: 'Car Shop',
            techUsed: 'HTML, CSS, Material UI, React, Node.js, Express.js, MongoDB, Firebase, HeroKu',
            desc1: "A niche product website of cars, where customers will be able to buy different types of cars.React Router has been used to navigate different components.",
            livesite: 'https://assignment12-1ebce.web.app/',
            serverSide: 'https://github.com/RIDOY-ZZAMAN/ridoy-carshop-server-side',
            clientSide: 'https://github.com/RIDOY-ZZAMAN/ridoy-carshop-client-side',
            desc2: " Authenticated users can access their dashboard to see their orders, cancel orders and can also give their reviews.",
            desc3: " An Admin has the priority to add products, manage products, see all products, see all orders, change the status of the orders and makes another admin from his dashboard.",
            desc4: "React Router has been used to navigate different components.",
            desc5: 'Total 4 Routes have been Created to Visit 4 different links on the home page Nav Bar.',
            img1: 'https://i.ibb.co/9tcV9bt/p1img1.png',
            img2: 'https://i.ibb.co/bBHhQy3/p1img2.png',
            img3: 'https://i.ibb.co/Qr7HfWs/p1img3.png'

        },
        {
            id: 2,
            name: 'Travel',
            techUsed: 'HTML, CSS, Bootstrap5, React, Node.js, Express.js, MongoDB, Firebase, HeroKu',
            desc1: "A tourism-related website where clients can book their tour.",
            desc2: "Users can see the detailed information of each service.",
            desc3: "A new service can be added and bookings can be managed.",
            desc4: "React Router has been used to navigate different components.",
            desc5: "Total 6 Routes have been Created to Visit 6 different links.",
            livesite: 'https://node-mongo-assignment11.web.app',
            serverSide: 'https://github.com/RIDOY-ZZAMAN/ridoy-travel-server-side',
            clientSide: 'https://github.com/RIDOY-ZZAMAN/ridoy-travel-client-side',

            img1: 'https://i.ibb.co/FWsH3dr/p2img1.png',
            img2: 'https://i.ibb.co/2Zb11KS/p2img2.png',
            img3: 'https://i.ibb.co/9WS0pgZ/p2img3.png'

        },
        {
            id: 3,
            name: 'MediNova Health Center',
            techUsed: 'HTML, CSS, Bootstrap5, React, Firebase',
            desc1: "A healthcare-related website where clients can book their tour. can see all the services.",
            desc2: "2 different types of Login sytems 1. Email and Password 2. Google Sign In",
            desc3: "Autenticated Users can see appointment",
            desc4: "React Router has been used to navigate different components.",
            desc5: "Total 5 Routes have been Created to Visit 5 different links and 2 Private Route Created",
            livesite: 'https://healthcareassignment10.web.app',
            clientSide: 'https://github.com/RIDOY-ZZAMAN/health-care-website',
            img1: 'https://i.ibb.co/Mf6py5R/p3img1.png',
            img2: 'https://i.ibb.co/PzZWCpd/p3img2.png',
            img3: 'https://i.ibb.co/mzG79hy/p3img3.png'

        },
        {
            id: 4,
            name: 'C3 Programming Center',
            techUsed: 'HTML, CSS, React-Bootstrap, React',
            desc1: "A Programming Language Learning Related website ",
            desc2: "Users can see all the programming language courses.",
            desc3: "Users can see details of all courses.",
            desc4: "Total 4 Routes Created to Visit 4 different links.",
            desc5: "React Router has been used to navigate different components.",
            livesite: 'https://optimistic-morse-6d9a16.netlify.app/',
            clientSide: 'https://github.com/RIDOY-ZZAMAN/C3-PROGRAMMING-CENTER',
            img1: 'https://i.ibb.co/CKh1HTV/p4img1.png',
            img2: 'https://i.ibb.co/Kx9XSp2/p4img2.png',
            img3: 'https://i.ibb.co/Q6KZLm7/p4img3.png'


        },
        {
            id: 5,
            name: 'Honda CBR',
            techUsed: 'HTML,CSS,Bootstrap5',
            desc1: "A Honda selling  Related website ",
            desc2: "Users can all the featured Honda",
            desc3: "Users can see clients feedback",
            desc4: "Bootstrap5 used to design the whole website",
            desc5: "Mobile Responsive",
            livesite: 'https://blissful-shaw-7c2d34.netlify.app/',
            clientSide: 'https://github.com/RIDOY-ZZAMAN/honda-crb',
            img1: 'https://i.ibb.co/Fmc6QKD/p5img1.png',
            img2: 'https://i.ibb.co/fSPn09B/p5img2.png',
            img3: 'https://i.ibb.co/BKg2G1q/p5img3.png'

        },
    ]
    useEffect(() => {
        const matchedProject = projectsDetails.find(project => project.id === parseInt(projectId));
        console.log(matchedProject);
        setProjects(matchedProject)
    }, [projectId,])



    return (
        <div className="text-start container">
            <h4 className="my-3 text-center">Projects Details</h4>
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-12">
                        <div class="card text-center">
                            <div class="card-header">
                                <div id="carouselExampleDark" class="carousel carousel-dark slide" data-bs-ride="carousel">
                                    <div class="carousel-indicators">
                                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    </div>
                                    <div class="carousel-inner">
                                        <div class="carousel-item active" data-bs-interval="10000">
                                            <img src={projects.img1} class="d-block w-100" alt="..." />
                                            <div class="carousel-caption d-none d-md-block">


                                            </div>
                                        </div>
                                        <div class="carousel-item" data-bs-interval="2000">
                                            <img src={projects.img2} class="d-block w-100" alt="..." />
                                            <div class="carousel-caption d-none d-md-block">

                                            </div>
                                        </div>
                                        <div class="carousel-item">
                                            <img src={projects.img3} class="d-block w-100" alt="..." />
                                            <div class="carousel-caption d-none d-md-block">

                                            </div>
                                        </div>
                                    </div>
                                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
                                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span class="visually-hidden">Previous</span>
                                    </button>
                                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="visually-hidden">Next</span>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body">
                                <h5 class="card-title">Projects {projects.id}</h5>

                                <a href={projects.livesite} target="_blank"
                                    rel="noopener noreferrer"><button type="button" className="btn btn-success my-2 ">Live Site</button></a>

                                <a href={projects.clientSide} target="_blank"
                                    rel="noopener noreferrer"><button type="button" className="btn btn-success my-2 mx-3">Client Side Code</button></a>

                                {projects.id === 1 && (< a href={projects.serverSide} target="_blank"
                                    rel="noopener noreferrer"><button type="button" className="btn btn-success my-2">Server Side Code</button></a>)}
                                {projects.id === 2 && (< a href={projects.serverSide} target="_blank"
                                    rel="noopener noreferrer"><button type="button" className="btn btn-success my-2">Server Side Code</button></a>)}

                            </div>

                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <h4 className="text-center">Overview Of The Project</h4>
                        <p className="ps-5" > <li>{projects.desc1}</li> </p>
                        <p className="ps-5" > <li>{projects.desc2}</li> </p>
                        <p className="ps-5" > <li>{projects.desc3}</li> </p>
                        <p className="ps-5" > <li>{projects.desc4}</li> </p>
                        <p className="ps-5" > <li>{projects.desc5}</li> </p>
                        <h4 className="text-center">Technology Used</h4>
                        <h6 className="text-center ps-5">{projects.techUsed}</h6>
                    </div>
                </div>
            </div>

        </div >
    );
};

export default ProjectDetails;